let guid = 1000;
export function createGuid(): number {
    return guid++;
}
